export default __webpack_public_path__ + "static/media/leftarrow.299ca2a1.svg";